export default __webpack_public_path__ + "media/images/react_icons/duplex_build-1d57c1d38b6f3788689c79ef34af4e24.svg";